export default Object.freeze({
  audioCodec: {
    title: 'Audio codec',
    message: 'Audio Codec settings contain the group of settings related to audio encoding.',
  },
  codecProfile: {
    title: 'Audio Codec Profile',
    message: 'AAC Profile',
  },
  bitrateControlMode: {
    title: 'Bitrate Control Mode',
    message: 'Bitrate control dictates how the encoder allocates the encoded audio data within the file. CBR stands fro constant bitrate and is an encoding method that keeps the bitrate the same. VBR is a variable bitrate.',
  },
  codingMode: {
    title: 'Coding mode',
    message: 'Mono (Audio Description), Mono, Stereo, or 5.1 channel layout. Valid values depend on rate control mode and profile. "1.0 - Audio Description (Receiver Mix)" setting receives a stereo description plus control track and emits a mono AAC encode of the description track, with control data emitted in the PES header as per ETSI TS 101 154 Annex E.',
  },
  bitrate: {
    title: 'Audio Bitrate',
    message: 'Specify the average bitrate in kilobits per second. The set of valid values for this setting is: 64, 80, 96, 112, 128, 160, 192, 224, 256, 288, 320, 384, 448, 512, 576. The value you set is also constrained by the values that you choose for Profile, Bitrate control mode, and Sample rate. Default values depend on Bitrate control mode and Profile.',
  },
  sampleRate: {
    title: 'Sample Rate',
    message: 'Sample rate in Hz. Valid values depend on rate control mode and profile.',
  },
  rawFormat: {
    title: 'Raw Format',
    message: 'Enables LATM/LOAS AAC output.',
  },
  specification: {
    title: 'Specification',
    message: 'Use MPEG-2 AAC instead of MPEG-4 AAC audio for raw or MPEG-2 Transport Stream containers.',
  },
  broadcasterMix: {
    title: 'Audio Description Broadcaster Mix',
    message: 'Choose Broadcaster Mixed Ad when the input contains pre-mixed main audio + audio description as a stereo pair. The value for AudioType will be set to 3, which signals to downstream systems that this stream contains "broadcaster mixed AD". Note that the input received by the encoder must contain pre-mixed audio; the encoder does not perform the mixing.Choose NORMAL when the input does not contain pre-mixed audio + audio description.',
  },
  transcribe: {
    title: 'Transcribe',
    message: 'With transcription enabled, automatic speech recognition will be used for generating text captions in the detected language. Output will be generated in srt, vtt, txt and json format.',
  },
})
